import WarningIcon from "./icons/WarningIcon";
import NotificationIcon from "./icons/NotificationIcon";
import { ReactNode } from "react";
export const AlertMessage = (props: {
  children: ReactNode;
  className?: string;
  warningIcon?: boolean;
  notificationIcon?: boolean;
  type?: "success" | "danger" | "warning" | "info" | "primary";
  heading?: string;
}) => {
  const { children, className, warningIcon, notificationIcon, type, heading } =
    props;
  return (
    <div
      className={`alert alert-${type ? type : "warning"}${
        className ? ` ${className}` : ""
      } d-flex gap-3 flex-column flex-100`}
      role="alert"
    >
      {notificationIcon || warningIcon || heading ? (
        <div className="d-flex gap-3 align-items-center">
          {notificationIcon ? (
            <span className="flex-shrink-0">
              <NotificationIcon />
            </span>
          ) : null}
          {warningIcon ? (
            <span className="flex-shrink-0">
              <WarningIcon height={22} />
            </span>
          ) : null}
          {heading ? (
            <h4 className="alert-heading flex-grow-1">{heading}</h4>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      <div className="w-100">{children}</div>
    </div>
  );
};
